<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.el-tree-node__content {
  white-space: pre-wrap !important;
  height: auto !important;
}
.el-tree-node__expand-icon {
  display: none !important;
}
.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  text-align:left;
  padding: 15px 30px 15px 15px;
  background: #4c555d;
  border-bottom: 1px solid #dadada;
  color: white;
}
div[role="group"] .el-tree-node.is-focusable .el-tree-node__content .el-tree-node__label{
  font-size: 18px !important;
}
.el-tree-node__label {
  font-size: 24px;
  margin-left:15px;
}
.el-tree-node__content{
  text-align:left;
  padding: 15px 30px 15px 15px;
  background: white;
  border-bottom: 1px solid #dadada;
  color: black;
}
.el-button--primary{
  font-family: 'Oswald', sans-serif;
}
#app {
   font-family: 'Oswald', sans-serif;
 /* font-family: Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue